enum UserType {
  sender = 'sender',
  receiver = 'receiver',
}

export default UserType;
